import Link from "../ui/Link";

export default function Navbar() {
    return (
        <div className="flex justify-between p-4">
            <div class="text-xl font-display font-bold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500">
                MyPortfolio
            </div>
            <div className="flex gap-8 p-3">
                <Link href="#home">Home</Link>
                <Link href="#about">About</Link>
                <Link href="#projects">Projects</Link>
                <Link href="#contact">Contact</Link>
            </div>
        </div>
    )
}